import { styled } from 'styled-components';

import { colors, cssBreakpoints, gutterWidth, maxWidth } from '#/theme/theme';

export const LayoutFullWidthBody = styled.div<{ $centered?: boolean }>`
  width: auto;
  max-width: ${(props) => (props.$centered ? 960 : maxWidth[3])}px;
  margin-left: auto;
  margin-right: auto;
  padding: ${gutterWidth / 2}px;
  color: ${colors.mediumContentGrey};
  line-height: 1.5;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    padding: ${gutterWidth}px;
  }
`;
